<template>
  <div class="col-12">
    <ClassSubjectFilter 
      @search="handleSearch" 
      @status="handleStatusFilter" 
      @add="navigateToAdd" 
    />

    <div class="card mb-5" style="margin-top: 4rem; overflow: visible">
      <div class="card-header p-0 position-relative mt-n4 mx-3 z-index-2" style="height: 60px;">
        <div class="bg-gradient-primary shadow-primary border-radius-lg pt-4 pb-3 h-100">
          <div class="d-flex justify-content-between align-items-center">
            <h6 class="text-white text-capitalize ps-3 pe-3">
              {{ $t('classSubjects.tableTitle') }} {{ className }}
            </h6>
          </div>
        </div>
      </div>

      <div class="card-body px-0 pb-2 pe-3">
        <ClassSubjectTable
          :items="classSubjects"
          :loading="loading"
          :class-id="classId"
          @delete="confirmDelete"
        />
      </div>
    </div>

    <DeleteDialog
      ref="deleteDialog"
      :title="$t('classSubjects.deleteTitle')"
      :message="$t('classSubjects.deleteMessage')"
      :confirm-text="$t('classSubjects.deleteConfirm')"
      @confirm="deleteClassSubject"
    />
  </div>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { useToast } from 'vue-toastification';
import ClassSubjectTable from '@/components/features/classsubjects/ClassSubjectTable.vue';
import ClassSubjectFilter from '@/components/features/classsubjects/ClassSubjectFilter.vue';
import DeleteDialog from '@/components/features/classsubjects/dialogs/DeleteClassSubjectDialog.vue';

import { useI18n } from 'vue-i18n';
const { t } = useI18n();

const toast = useToast();
const route = useRoute();
const router = useRouter();
const store = useStore();
const deleteDialog = ref(null);

const classId = route.params.id;
const loading = ref(false);
const filters = ref({ search: '', status: '' });
const className = computed(() => store.state.classes.currentClass?.name || '');
const classSubjects = computed(() => store.state.classsubjects.classSubjects || []);

const fetchClassSubjects = async () => {
  try {
    loading.value = true;
    await store.dispatch('classsubjects/fetchClassSubjects', {
      classId,
      search: filters.value.search,
      status: filters.value.status
    });
  } catch (error) {
    toast.error(t('classSubjects.fetchError'));
  } finally {
    loading.value = false;
  }
};

const handleSearch = (search) => {
  filters.value.search = search;
  fetchClassSubjects();
};

const handleStatusFilter = (status) => {
  filters.value.status = status;
  fetchClassSubjects();
};

const confirmDelete = (subject) => {
  deleteDialog.value.open(subject);
};

const deleteClassSubject = async (subject) => {
  try {
    await store.dispatch('classsubjects/removeSubjectFromClass', {
      classId,
      subjectId: subject.subject_id || subject.id
    });
    toast.success(t('classSubjects.deleteSuccess'));
    fetchClassSubjects();
  } catch (error) {
    toast.error(error.response?.data?.message || t('classSubjects.deleteError'));
  }
};

const navigateToAdd = () => {
  router.push(`/classes/${classId}/subjects/add`);
};

onMounted(async () => {
  await Promise.all([
    store.dispatch('classes/fetchClass', classId),
    fetchClassSubjects()
  ]);
});
</script>
